<template>
  <div class="PanicBuying">
      <div class="page-module">
        

        <div :class="{'item':true, 'btn-left':true, 'no-drop': page == 1} ">
            <div class="swiper-button-prev"></div>
            <!-- <img @click="nextPage(1)" src="~common/images/report/index/icon-new_left_raduis.png" alt="左侧"> -->
        </div>
        <div class="item content">
            <div class="panicBuying-list">

                <div class="swiper-container">
                    <div class="swiper-wrapper">
                        <div class="swiper-slide">
                            <div :class="{'panicBuying-item': index < 5}" v-for="(item,index) in limitedtimelist" :key="index"  @click="routedetails(item.innerid)">
                                <template v-if="index < 5">
                                    <div class="bg-img">
                                        <img v-lazy="item.coverurl" :alt="item.subject">
                                    </div>
                                    <p class="msg">{{item.subject}}</p>
                                    <div class="money">
                                        <p class="first">{{item.saleprice}}元</p>
                                        <p class="underlines">{{item.uprice}}元</p>
                                        <p class="btn">抢购</p>
                                    </div>
                                </template>
                            </div>
                        </div>
                        <div class="swiper-slide" v-if="limitedtimelist.length > 5">
                            <div :class="{'panicBuying-item': index > 4 && index < 10}"  v-for="(item,index) in limitedtimelist" :key="index"  @click="routedetails(item.innerid)">
                               <template v-if="index > 4 && index < 10">
                                    <div class="bg-img">
                                        <img v-lazy="item.coverurl" :alt="item.subject">
                                    </div>
                                    <p class="msg">{{item.subject}}</p>
                                    <div class="money">
                                        <p class="first">{{item.saleprice}}元</p>
                                        <p class="underlines">{{item.uprice}}元</p>
                                        <p class="btn">抢购</p>
                                    </div>
                               </template>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>
        <div  :class="{'item':true, 'btn-right':true, 'no-drop': page == 2}" >
            
            <div class="swiper-button-next"></div>
            <!-- <img @click="nextPage(2)" src="~common/images/report/index/icon-new_right_raduis.png" alt="右侧"> -->
        </div>
      </div>
  </div>
  <!-- 抢购 end  -->
</template>

<script>
import Swiper from 'swiper/js/swiper.min.js'
// import Swiper from 'swiper'
import 'swiper/css/swiper.min.css'
export default {
  props: ['limitedtimelist'],
  name: 'PanicBuying',
  data () {
    return {
        page: 1
    }
  },
  mounted () {
    //   this.$nextTick(() => {
         
    //   })
  },
  updated() {
       this.$nextTick(() => {
           this.initSwiper()
           console.log('执行sw')
       })
  },
  methods: {
      nextPage (page) { // 翻页
        this.page = page
        this.$parent.getIndexReportList(page)
      },
    routedetails(innerid) {
      this.$parent.routerDetails(innerid)
    },
    initSwiper() {
        new Swiper('.PanicBuying .swiper-container', {
              autoplay: {
                disableOnInteraction: false,
                delay: 5000, // 5秒切换一次
            //     stop: true
              },
              navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            }
          })
    }
      
  },
  filters: {},
  watch: {},
  computed: {},
  components: {}
}
</script>

<style lang="scss" type="text/scss" scoped>
.PanicBuying {
    height:306px;
    // background:rgba(245,245,245,1);
    
    .page-module {
        position: relative;
        background:rgba(245,245,245,1);
    }
    .swiper-button-next:after, .swiper-button-prev:after,
    .swiper-button-next:after, .swiper-container-rtl .swiper-button-prev:after {
        content: '';
       
    }
    .swiper-button-prev {
        position: relative;
        margin-top: 117px;
        opacity: 1;
        left: 0;
        width: 16px;
        height: 32px;
        cursor: pointer;
        background: url('./../../../../common/images/report/index/icon-new_left_raduis.png');
        background-size: 16px 32px;
    }
    .swiper-button-next {
        position: relative;
        margin-top: 117px;
        opacity: 1;
        right: 0;
        width: 16px;
        height: 32px;
        cursor: pointer;
        background: url('./../../../../common/images/report/index/icon-new_right_raduis.png');
        background-size: 16px 32px;
    }

    .item {
        float: left;
    }
    // .no-drop {
    //     .swiper-button-prev,
    //     .swiper-button-next {
    //         cursor: no-drop !important;
    //     }
    // }
    .content {
        margin: 20px 0;
        width: calc(100% - 32px);
        height:266px;
        background:rgba(255,255,255,1);

        .panicBuying-list {
            // .panicBuying-item ~ .panicBuying-item {
            //     margin-left: 29px;
            // }
            .panicBuying-item {
                float: left;
                margin-top: 20px;
                margin-left: 29px;
                width: 196px;
                cursor: pointer;
                .bg-img {
                    position: relative;
                    img {
                        position: relative;
                        z-index: 2;
                        width: 190px;
                        height: 112px;
                    }
                    &::after {
                    content: '';
                        position: absolute;
                        top: 0;
                        display: block;
                        width: 196px;
                        height:112px;
                        background-image: url('./../../../../common/images/report/index/img_bg.png');
                        background-size: 100%;
                    }
                }
                .msg {
                    margin-top: 12px;
                    font-size: 14px;
                    line-height: 18px;
                    height: 54px;
                    text-overflow: -o-ellipsis-lastline;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    display: -webkit-box;
                    -webkit-line-clamp: 3;
                    -webkit-box-orient: vertical;
                    word-break: break-all;
                    &:hover {
                        color: #409EFF;
                    }
                }
                .money {
                    margin-top: 20px;
                    height:28px;
                    line-height: 28px;
                    background: #D92430;
                    // border-bottom: solid 1px #D92430;
                    p {
                        float: left;
                        font-size: 14px;
                        color: #fff;
                        &.underlines {
                            margin-left: 4px;
                            text-decoration: line-through;
                            font-size: 12px;
                        }
                        &.first {
                            margin-left: 8px;
                        }
                        &.btn {
                            float: right;
                            padding: 0 10px;
                            height: 28px;
                            border: solid 1px #D92430;
                            background: #fff;
                            color: #D92430;
                            box-sizing: border-box;

                            &:hover {
                                color: #df2a36;
                            }
                        }
                    }
                }
            }
        }
    }
}
</style>